import React, { useState, useCallback } from "react";
import { shrinkRectOverlap } from "./collision"; // Import collision helper

const NPCLayer = ({ npcs, camX, camY, playerX, playerY, onNPCClick }) => {
  const [activeNPC, setActiveNPC] = useState(null);
  const [showDialogue, setShowDialogue] = useState(false);
  const [dialogueText, setDialogueText] = useState("");
  
  // Check if player is colliding with any NPC
  // This function can be called from GameMap to check collision
  const isCollidingWithNPC = useCallback((x, y) => {
    if (!npcs || npcs.length === 0) return false;
    
    return npcs.some(npc => {
      // Using 16x24 dimensions for NPCs as specified
      return shrinkRectOverlap(
        x, y, 32, 32, // Player hitbox (same as in TrainersLayer)
        npc.x, npc.y, 16, 24, // NPC hitbox (16x24 as specified)
        0, 0, 0, 0 // No padding
      );
    });
  }, [npcs]);
  
  // Expose the collision check function through a ref that GameMap can access
  NPCLayer.isCollidingWithNPC = isCollidingWithNPC;

  const handleNPCClick = (npc) => {
    if (npc.dialogue) {
      // Show dialogue for this NPC
      setActiveNPC(npc);
      setDialogueText(npc.dialogue);
      setShowDialogue(true);
    } else {
      // Pass to parent for modal handling
      onNPCClick(npc);
    }
  };

  const closeDialogue = () => {
    setShowDialogue(false);
    setActiveNPC(null);
  };

  return (
    <>
      {/* Render NPCs */}
      {npcs && npcs.map(npc => (
        <div
          key={npc.id}
          className="npc"
          onClick={() => handleNPCClick(npc)}
          style={{
            position: 'absolute',
            left: npc.x - camX,
            top: npc.y - camY,
            width: npc.width || 32,
            height: npc.height || 32,
            backgroundImage: `url(${npc.sprite})`,
            backgroundPosition: `-${(npc.step || 0) * 32}px -${(npc.direction || 0) * 32}px`,
            cursor: 'pointer',
            zIndex: 100,
            imageRendering: 'pixelated'
          }}
        />
      ))}

      {/* Dialogue box */}
      {showDialogue && activeNPC && (
        <div 
          className="dialogue-box"
          style={{
            position: 'absolute',
            bottom: '10%',
            left: '10%',
            width: '80%',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            color: 'white',
            padding: '10px',
            borderRadius: '5px',
            border: '2px solid #ffcc00',
            zIndex: 1000,
            fontFamily: 'Arial, sans-serif',
            fontSize: '14px'
          }}
        >
          <div className="dialogue-header" style={{ marginBottom: '5px', fontWeight: 'bold' }}>
            {activeNPC.name || 'NPC'}:
          </div>
          <div className="dialogue-content">
            {dialogueText}
          </div>
          <div 
            className="dialogue-close" 
            style={{ 
              marginTop: '10px', 
              textAlign: 'right', 
              color: '#ffcc00',
              cursor: 'pointer'
            }}
            onClick={closeDialogue}
          >
            [Click to close]
          </div>
        </div>
      )}
    </>
  );
};

export default NPCLayer;
